import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Slider from '@wix/da-ds/pkg/Slider';
import { MeasuredContainer, measuredDefaultSize, MeasuredCookieType, ScreenSizeContext } from '../Measured';
import { getSliderConfiguration } from '@wix/da-ds/pkg/Slider/helpers';
import { BREAKPOINTS as breakpoints } from '@wix/da-ds/pkg/Slider/constants';
const MeasuredSlider = (_param)=>{
    var { children, renderSliderItems } = _param, restProps = _object_without_properties(_param, [
        "children",
        "renderSliderItems"
    ]);
    const { width: screenWidth } = useContext(ScreenSizeContext);
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(MeasuredContainer, {
        cookieType: MeasuredCookieType.SLIDER,
        cookieDim: 'width',
        defaultSize: measuredDefaultSize,
        listenOnWindow: true,
        limitToParentWidth: true
    }, (measuredProps)=>{
        const containerWidth = measuredProps.container && measuredProps.container.width;
        const { elementWidth, elementHeight } = getSliderConfiguration({
            breakpoints,
            screenWidth,
            containerWidth,
            dontScale: isMobile
        });
        return /*#__PURE__*/ React.createElement(Slider, restProps, renderSliderItems({
            width: elementWidth,
            height: elementHeight
        }));
    });
};
MeasuredSlider.displayName = 'MeasuredSlider';
export default MeasuredSlider;
